import React from 'react';
import { Link } from "react-router-dom"

import FirstTitle from "./../../shared/items/static/firstTitle"
import Paragraph from "./../../shared/items/static/paragraph"
import locales from "./../../content.json"

import styles from './faq.module.scss'

const Faq = () => {
  return (
    <div className={styles.faq}>
      <div className={styles.logo}>
        <Link to="/"><img src="./img/logo.png" alt="logo" /></Link>
      </div>

      <div className={styles.container_firstTitle}>
        <FirstTitle>{locales[window.userLang].faq}</FirstTitle>
      </div>

      <div className={styles.faqData}>
        <div className={styles.contactItem}>
          <span className={styles.title}>{locales[window.userLang].how_to}</span>
          <div className={styles.container_contentWrapper}>
            <Paragraph>{locales[window.userLang].to_get} <Link to="/">{locales[window.userLang].this_page}</Link>{locales[window.userLang].and_answer}</Paragraph>
          </div>
        </div>
        
        <div className={styles.contactItem}>
          <span className={styles.title}>{locales[window.userLang].how_will}</span>
          <div className={styles.container_contentWrapper}>
            <Paragraph>{locales[window.userLang].unique_download} <a href="mailto:support@verv.com">support@verv.com</a>.</Paragraph>
          </div>
        </div>

        <div className={styles.contactItem}>
          <span className={styles.title}>{locales[window.userLang].when_will}</span>
          <div className={styles.container_contentWrapper}>
            <Paragraph>{locales[window.userLang].our_smart}</Paragraph>
          </div>
        </div>

        <div className={styles.contactItem}>
          <span className={styles.title}>{locales[window.userLang].what_happened}</span>
          <div className={styles.container_contentWrapper}>
            <Paragraph>{locales[window.userLang].as_you_purchase}</Paragraph>
          </div>
        </div>

        <div className={styles.contactItem}>
          <span className={styles.title}>{locales[window.userLang].cancel_my_subscription}</span>
          <div className={styles.container_contentWrapper}>
            <Paragraph>{locales[window.userLang].please_note} <Link to="/">{locales[window.userLang].this_page_2}</Link> {locales[window.userLang].one_time_only}</Paragraph>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Faq;